(function () {
  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents);
    }
    return '£' + (cents / 100).toFixed(2);
  }

  document.querySelectorAll('[data-ss-bundle]').forEach(function (section) {
    var min = parseInt(section.dataset.min, 10) || 2;
    var discountPercent = parseFloat(section.dataset.discountPercent) || 25;
    var selected = new Map();
    var bar = section.querySelector('[data-ss-bundle-bar]');
    if (!bar) return;

    var countEl = bar.querySelector('[data-ss-bundle-count]');
    var savingsEl = bar.querySelector('[data-ss-bundle-savings]');
    var checkoutBtn = bar.querySelector('[data-ss-bundle-checkout]');

    section.querySelectorAll('[data-ss-bundle-add-pair]').forEach(function (pairBtn) {
      var defaultPairLabel = pairBtn.textContent.trim();
      pairBtn.addEventListener('click', function () {
        if (pairBtn.disabled) return;
        var ids = (pairBtn.dataset.variantIds || '').split(',').filter(Boolean);
        if (ids.length === 0) return;

        pairBtn.disabled = true;
        pairBtn.textContent = 'Adding…';

        ids.forEach(function (id) {
          var addBtn = section.querySelector('[data-ss-bundle-add][data-variant-id="' + id + '"]');
          if (addBtn && !addBtn.disabled && !addBtn.classList.contains('is-added')) {
            addBtn.click();
          }
        });

        pairBtn.disabled = false;
        pairBtn.textContent = defaultPairLabel;
      });
    });

    section.querySelectorAll('[data-ss-bundle-add]').forEach(function (btn) {
      var defaultLabel = btn.textContent.trim();
      btn.dataset.defaultLabel = defaultLabel;

      btn.addEventListener('click', function () {
        var id = btn.dataset.variantId;
        if (!id || btn.disabled) return;

        var priceCents = parseInt(btn.dataset.variantPriceCents, 10) || 0;

        if (selected.has(id)) {
          selected.delete(id);
          btn.classList.remove('is-added');
          btn.textContent = defaultLabel;
        } else {
          selected.set(id, { priceCents: priceCents });
          btn.classList.add('is-added');
          btn.textContent = btn.dataset.addedLabel || 'Added';
        }
        updateBar();
      });
    });

    section.querySelectorAll('[data-ss-bundle-card]').forEach(function (card) {
      card.addEventListener('ss-edition-change', function (event) {
        var detail = event.detail || {};
        var addBtn = card.querySelector('[data-ss-bundle-add]');
        if (!addBtn) return;

        var pill = card.querySelector('[data-ss-edition-option].is-active');
        if (pill && pill.dataset.variantPriceCents) {
          addBtn.dataset.variantPriceCents = pill.dataset.variantPriceCents;
        }

        if (addBtn.classList.contains('is-added') && detail.oldId && detail.oldId !== detail.newId) {
          selected.delete(detail.oldId);
          if (detail.available) {
            var priceCents = parseInt(addBtn.dataset.variantPriceCents, 10) || 0;
            selected.set(detail.newId, { priceCents: priceCents });
            addBtn.classList.add('is-added');
            addBtn.textContent = addBtn.dataset.addedLabel || 'Added';
          } else {
            addBtn.classList.remove('is-added');
            addBtn.textContent = addBtn.dataset.defaultLabel || 'Add to bundle';
          }
          updateBar();
        } else if (!detail.available) {
          addBtn.classList.remove('is-added');
          if (detail.oldId) selected.delete(detail.oldId);
          updateBar();
        } else if (addBtn.classList.contains('is-added') && detail.newId) {
          var updatedPrice = parseInt(addBtn.dataset.variantPriceCents, 10) || 0;
          selected.set(detail.newId, { priceCents: updatedPrice });
          updateBar();
        }
      });
    });

    function updateBar() {
      var n = selected.size;
      if (countEl) countEl.textContent = n + ' of ' + min + ' selected';
      if (checkoutBtn) checkoutBtn.disabled = n < min;
      bar.hidden = n === 0;

      if (savingsEl) {
        if (n >= min) {
          var subtotal = 0;
          selected.forEach(function (entry) {
            subtotal += entry.priceCents || 0;
          });
          var savings = Math.round(subtotal * (discountPercent / 100));
          savingsEl.textContent = 'Est. savings ' + formatMoney(savings) + ' (' + discountPercent + '% off)';
          savingsEl.hidden = false;
        } else {
          savingsEl.hidden = true;
          savingsEl.textContent = '';
        }
      }
    }

    if (checkoutBtn) {
      checkoutBtn.addEventListener('click', function () {
        if (selected.size < min) return;

        var items = Array.from(selected.keys()).map(function (id) {
          return { id: parseInt(id, 10), quantity: 1 };
        });

        checkoutBtn.disabled = true;
        checkoutBtn.textContent = 'Adding…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items }),
        })
          .then(function (res) {
            if (!res.ok) throw new Error('Cart add failed');
            window.location.href = '/cart';
          })
          .catch(function () {
            checkoutBtn.disabled = false;
            checkoutBtn.textContent = checkoutBtn.dataset.label || 'Checkout bundle';
            alert('Something went wrong adding items. Please try again.');
          });
      });
    }
  });
})();
